import OrderPromoSummary from '../../../promo/OrderPromoSummary';
import React from 'react';
import { defineOrderStatusClassName, getOrderStatusMainLabel, renderOrderStatusAdminLabel } from '../../../../utils/adminOrderService';

export default function AdminOrderSummary({ order }) {
  const status = order.orderStatus;
  const detail = renderOrderStatusAdminLabel(status);
  return (
    <>
      <div className='d-flex justify-content-between align-items-start'>
        <div className='mr-3'>
          <div className='font-weight-bold'>Замовлення #{order.orderId}</div>
          <div className='small'>
            {[order.userInfo?.surname, order.userInfo?.name].filter(Boolean).join(' ')}
          </div>
        </div>
        {status && (
          <div className='text-right flex-shrink-0' style={{ maxWidth: '48%' }}>
            <span
              className={defineOrderStatusClassName(status).replace('dropdown-toggle', '')}
              style={{ fontSize: '0.7rem', padding: '0.25rem 0.4rem', whiteSpace: 'normal' }}
            >
              {getOrderStatusMainLabel(status)}
            </span>
            {detail && <div className='small mt-1'>{detail}</div>}
          </div>
        )}
      </div>
      <div className='small text-muted mt-1'>
        Сума:{' '}
        <span className='font-weight-bold'>
          {Number(order.discountedPrice ?? order.price ?? 0).toLocaleString('uk-UA')} грн
        </span>
      </div>
      <OrderPromoSummary order={order} />
    </>
  );
}
